import Head from 'next/head';
import { BlogPosting, WithContext } from 'schema-dts';
import { PartialItem, PostProps } from 'types';

export interface BlogPostingSchemaProps {
  url: string
  post: PartialItem<PostProps>
  imageUrl: string
};

export default function Schema(props: BlogPostingSchemaProps): JSX.Element {
  const schema: WithContext<BlogPosting> = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    'inLanguage': 'English',
    'url': props.url,
    'name': props.post.title,
    'headline': props.post.title,
    'datePublished': props.post.publishedAt,
    'dateCreated': props.post.publishedAt,
    'dateModified': props.post.publishedAt,
    "image": props.imageUrl,
  };
  return (
    <Head>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Head>
  )
};
